import { createSlice } from "@reduxjs/toolkit";

const ProjectSlice = createSlice({
    name: "Project",
    initialState: {
    selectedBlogCard:null
    },
    reducers: {
        handleSelectBlogCard: (state, action) => {
            state.selectedBlogCard = action.payload;
        }
    },
});

export const {
    handleSelectBlogCard
} = ProjectSlice.actions;
export default ProjectSlice.reducer;
